package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.InventoryRepository

class DeleteInventoryItemImageUseCase(
    private val imageStorageRepository: ImageStorageRepository,
    private val inventoryRepository: InventoryRepository
) {
    suspend operator fun invoke(characterId: String, itemId: String): Result<Unit> {
        imageStorageRepository.delete(ImageTarget.InventoryItem(characterId, itemId))
        return inventoryRepository.updateImageUrl(itemId, null).map { }
    }
}
